<!--昆明定制登陆页面-->
<template>
  <el-container>
    <el-header id="header" height="120px"
               style="border-top-left-radius: 5px; border-top-right-radius: 5px; background-color: rgb(83,174,221)">
      <div style="height:24px; line-height: 24px; text-align: right; padding-right: 20px; ">
        <a href="http://www.kmsfybjy.com/" target="_blank">返回首页</a>
        &nbsp;|&nbsp;咨询热线：<span style="color:red;">0871-63624024</span>
      </div>
      <div style="">
        <img src="../assets/km/logon.png"/>
      </div>
    </el-header>
    <el-container v-bind:style="containerStyle">
      <div class="mainContainer">
        <div class="tile">区域检验检查报告单查询平台</div>
        <el-container>
          <el-main>
            <img src="../assets/km/main.jpg"/>
          </el-main>
          <el-aside width="350px" class="login" style="overflow: hidden">
            <login v-on:loginSuccess="loginSuccess"></login>
          </el-aside>
        </el-container>
      </div>
    </el-container>
    <el-footer id="footer" height="40px">
      云康健康产业集团有限公司
    </el-footer>
  </el-container>
</template>

<script>
  import Login from '../components/Login'
  import {keyCodes} from '../commons'

  export default {
    data() {
      return {
        containerHeight: 0
      }
    },
    props: {},
    computed: {
      containerStyle: function () {
        return {
          height: this.containerHeight + 'px',
          maxHeight: this.containerHeight + 'px',
          border: '2px solid rgb(83,174,221)',
        }
      }
    },
    components: {
      Login,
    },
    methods: {
      /**
       * 登陆成功后回调
       */
      loginSuccess(){
        const _this = this;
        _this.$store.dispatch('setLoginBy',keyCodes.LOGIN_BY_KM)
      }
    },
    watch: {},
    mounted() {
      const _this = this;
      _this.containerHeight = window.innerHeight - $('#header').outerHeight() - $('#footer').outerHeight();
      window.onresize = function windowResize() {
        _this.containerHeight = window.innerHeight - $('#header').outerHeight() - $('#footer').outerHeight();
      }
    }
  }
</script>

<style scoped>
  .mainContainer {
    width: 1150px;
    margin: 100px auto;

  }

  .mainContainer .tile {
    font-size: 24px;
    font-weight: bold
  }

  .mainContainer main {
    padding: 0px;
    overflow: hidden;
  }

  .mainContainer img {
    width: 785px;
    height: 350px;
  }

  .login {
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    margin: 0px auto;
  }

  #footer {
    line-height: 40px;
    color: white;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background-color: rgb(83, 174, 221);
    text-align: center;
    font-size: 14px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/LoginKunming.vue